export default __webpack_public_path__ + "static/media/guest_05_bianca_machado.3758f51c.png";